import Form from '../04-components/form';

const module = 'scorecard-form',
    selector = {
        base: `.js-${module}`
    };

export default class ScorecardForm extends Form {

    constructor(baseElement) {
        super(baseElement);
    }

    onSubmitHandler(ev) {
        if (this.$form.valid()) {
            const course = this.form.querySelector('[name=courseId]'),
                loop = this.form.querySelector('[name=loopId]'),
                tee = this.form.querySelector('[name=teeId]'),
                qualifying = this.form.querySelector('[name=qualifying]');

            dataLayer.push({
                'event': 'scorecard_create_complete',
                'course': course.options[course.selectedIndex].innerText,
                'holes': loop.options[loop.selectedIndex].innerText,
                'tee': tee.options[tee.selectedIndex].innerText,

                'Qualifying': qualifying.options[qualifying.selectedIndex].value === 'true',
                'eventCategory': 'scoreCard',


                'eventAction': 'create',
                'eventLabel': 'complete'
            });

            dataLayer.push({
                'event': 'scorecard_start',
                'course': course.options[course.selectedIndex].innerText,
                'holes': loop.options[loop.selectedIndex].innerText,
                'tee': tee.options[tee.selectedIndex].innerText,

                'Qualifying': qualifying.options[qualifying.selectedIndex].value === 'true',  
                'eventCategory': 'scoreCard',


                'eventAction': 'start',
                'eventLabel': 'in_progress'
            });
        }

        super.onSubmitHandler(ev);
    }
}

function initScoreCardForm() {
    document.querySelectorAll(selector.base).forEach((element) => {
        new ScorecardForm(element);
    });
}

initScoreCardForm();